/**
 * Work Order Code Constants
 * These constants are used for conditional logic in the application.
 * The actual display values are still fetched from the code value service.
 */

// Timesheet Approval Type Codes
export const TIMESHEET_APPROVAL_TYPE = {
  ALTERNATE: 'Alternate',
  SEQUENTIAL: 'Sequential',
  PARALLEL: 'Parallel'
} as const

export type TimesheetApprovalType = typeof TIMESHEET_APPROVAL_TYPE[keyof typeof TIMESHEET_APPROVAL_TYPE]

// Expense Methodology Codes (code strings from workorder.CodeExpenseMethodology)
export const EXPENSE_METHODOLOGY = {
  ONLINE_APPROVAL: 'OnlineApproval',
  OFFLINE_APPROVAL: 'OfflineApproval',
  THIRD_PARTY_IMPORT: 'ThirdPartyImport', // Not used in engagements
  NO_EXPENSE: 'NoExpense'
} as const

// Expense Methodology IDs (for filtering)
export const EXPENSE_METHODOLOGY_ID = {
  ONLINE_APPROVAL: 1,
  OFFLINE_APPROVAL: 2,
  THIRD_PARTY_IMPORT: 3, // Filter this out
  NO_EXPENSE: 4
} as const

export type ExpenseMethodology = typeof EXPENSE_METHODOLOGY[keyof typeof EXPENSE_METHODOLOGY]

// Rate Unit Type Codes
export const RATE_UNIT = {
  HOUR: 'Hour',
  DAY: 'Day'
} as const

export type RateUnit = typeof RATE_UNIT[keyof typeof RATE_UNIT]
